import { logError } from 'services/logging/logging';
import { PartyDTO } from 'support/types';

export const getPartyWithGS1orVAT = (parties: Array<PartyDTO>) => {
  const partyWithGS1orVAT = parties.find((party) =>
    party.identifiers?.some(
      (identifier) => (identifier.domain === 'GS1' || identifier.domain === 'vatID') && !!identifier.identifier,
    ),
  );

  if (partyWithGS1orVAT) {
    return partyWithGS1orVAT;
  }

  logError('Order Forms: No party with GS1 or VAT identifier found');
  return parties[0];
};
